import en from '@client/i18n/locales/en.json';
import { createI17n } from '@drewjbartlett/i17n';

/**
 * This is the core i18n instance to be shared among the app.
 */
export const i18n = createI17n({
  translations: en,
  countKey: 'count',
});
